import { Box, Grid, Typography } from "@material-ui/core";

import { BarChart } from "../charts";
import { ShaDowBox } from "../boxes";
import { NoDataCard } from "../parts";
import { ButtonWithTooltip } from "../base";
import { COLORS } from "../../theme/colors";
import { maxValue } from "../charts/DoubleBarChart";
import { useSelector } from "react-redux";

const bars = [
  {},
  {},
  {
    dataKey: "consumption",
    fill: COLORS.purple,
  },
];

export const LineBarLabel = (props) => {
  const { x, y, width, name, height } = props;
  const [title, subtitle] = (name || "").split("\n");

  return (
    <g x={x} y={y}>
      {name ? (
        <g>
          <svg x={x - 62 + width / 2} y={5} fill={COLORS.darks[0][100]} fillOpacity={0.1}>
            <path d="M 0 0 L 0 40 L 124 40 L 124 0 L 0 0" />
          </svg>
          <text
            dx={x + width / 2}
            dy={25}
            fill={COLORS.darks[0][100]}
            textAnchor="middle"
            fontSize={12}
          >
            {title}
          </text>
          <text
            dx={x + width / 2}
            dy={39}
            fill={COLORS.darks[0][100]}
            textAnchor="middle"
            fontSize={12}
          >
            {subtitle}
          </text>
          <path
            d={`M${x + 10},${45}L${x + 10},${160 - height}L${x + 10},${45}`}
            stroke={COLORS.darks[0][100]}
            strokeWidth={1}
          />
        </g>
      ) : (
        <text />
      )}
    </g>
  );
};

export const NALabel = (props) => {
  const { x, y, width } = props.viewBox;

  return (
    <g>
      <text
        x={x}
        y={y}
        dy={20}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        N/A
      </text>
    </g>
  );
};

export const PaymentDelayLabel = (props) => {
  const { x, y, width } = props.viewBox;
  return (
    <g>
      <text
        x={x}
        y={y}
        dy={20}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        Payment
      </text>
      <text
        x={x}
        y={y}
        dy={34}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        delays
      </text>
    </g>
  );
};

export const HighEconomicLabel = (props) => {
  const { x, y, width } = props.viewBox;

  return (
    <g>
      <text
        x={x}
        y={y}
        dy={20}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        High Economic
      </text>
      <text
        x={x}
        y={y}
        dy={34}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        vacancy rate
      </text>
    </g>
  );
};

export const HighPhysicalLabel = (props) => {
  const { x, y, width } = props.viewBox;
  return (
    <g>
      <text
        x={x}
        y={y}
        dy={20}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        High Physical
      </text>
      <text
        x={x}
        y={y}
        dy={34}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={12}
        textAnchor="middle"
      >
        vacancy rate
      </text>
    </g>
  );
};

export const ProfitabilityOverTime = ({
  chartData,
  title,
  buttonText,
  onClick,
  referenceAreas,
}) => {
  const { user } = useSelector((state) => state.auth);

  if (!user.is_demo || !chartData.length) return <NoDataCard title={title} />;
  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ marginBottom: 40 }}
        >
          <Typography variant="h4">{title}</Typography>
          <ButtonWithTooltip disabled onClick={onClick} text={buttonText} title="Comming soon" />
        </Grid>
        <BarChart
          yDomain={[0, maxValue]}
          chartData={chartData}
          bars={bars}
          xAxisPadding={{ left: 45, right: 40 }}
          referenceAreas={referenceAreas}
          showLabelList
          CustomLabelList={LineBarLabel}
        />
      </Box>
    </ShaDowBox>
  );
};

ProfitabilityOverTime.defaultProps = {
  referenceAreas: [],
};
